import { default as ICONS_CONFIG } from './icons.json'

import theme from 'theme_'

interface GlyphMap {
  [key: string]: string[]
}

const glyphMap = {} as GlyphMap

ICONS_CONFIG.icons.forEach(({ icon, properties }) => {
  glyphMap[properties.name] = icon.paths
})

export const getGlyph = (name: string) => {
  if (!glyphMap[name]) {
    return null
  }

  return (
    <svg width={18} height={18} viewBox="0 0 1024 1024">
      {glyphMap[name].map((path) => (
        <path key={path} d={path} fill={theme.colors.beachGrey} />
      ))}
    </svg>
  )
}
